import { ADMIN, COMMON, ifyouApi, ifyouApiLive, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

// 코인 상점
export const coinStoreApi = {
  read: () =>
    ifyouApi
      .post(`${ADMIN}/coin-product-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinStoreList_LIVE: () =>
    ifyouApiLive
      .post(`${ADMIN}/coin-product-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail: (coinProductId) =>
    ifyouApi
      .post(`${ADMIN}/${coinProductId}/coin-product-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinStoreDetail_LIVE: (coinProductId) =>
    ifyouApiLive
      .post(`${ADMIN}/${coinProductId}/coin-product-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  coinStoreRegister: (coin_product_id, inputData, langInputData, setList) =>
    ifyouApi
      .post(`${ADMIN}/coin-product-update`, {
        coin_product_id: coin_product_id, // 신규는 0
        currency: inputData?.currency?.toString(),
        is_public: inputData.is_public,
        is_common: inputData.is_common,
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        price: inputData.price,
        sale_price: inputData.sale_price,
        sale_kind: inputData.sale_kind,
        thumbnail_id: inputData.thumbnail_id,
        detail_page_id: inputData.detail_page_id,
        setList: setList,
        langList: langInputData,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinStoreRegister_LIVE: (
    coinProductId,
    selectProduct,
    isPublic,
    startDate,
    endDate,
    price,
    salePrice,
    saleKind,
    selectThumbnail,
    setList,
    langInputData,
  ) => {
    ifyouApiLive
      .post(`${ADMIN}/coin-product-update`, {
        coin_product_id: coinProductId, // 신규는 0
        currency: selectProduct,
        is_public: isPublic,
        start_date: startDate,
        end_date: endDate,
        price: price,
        sale_price: salePrice,
        sale_kind: saleKind,
        thumbnail_id: selectThumbnail,
        detail_page_id: 844,
        setList: setList,
        langList: langInputData,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  delete: (coinProductId) =>
    ifyouApi
      .post(`${ADMIN}/coin-product-delete`, {
        coin_product_id: coinProductId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinStoreDelete_LIVE: (coinProductId) =>
    ifyouApiLive
      .post(`${ADMIN}/coin-product-delete`, {
        coin_product_id: coinProductId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  currencyList: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'getCurrencyList', code: '1' })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  currencyList_Live: () =>
    ifyouApiLive
      .post(`${COMMON}`, { func: 'getCurrencyList', code: '1' })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  thumbnailImgList: () =>
    ifyouApi
      .post(`${STORY}/-1/com-design-select`, { design_type: 'coin_thumbnail' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  thumbnailImgList_LIVE: () =>
    ifyouApiLive
      .post(`${STORY}/-1/com-design-select`, { design_type: 'coin_thumbnail' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detailImgList: () =>
    ifyouApi
      .post(`${STORY}/-1/com-design-select`, {
        design_type: 'coin_detail_page',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detailImgList_LIVE: () =>
    ifyouApiLive
      .post(`${STORY}/-1/com-design-select`, {
        design_type: 'coin_detail_page',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinCurrencyThumb: (product) =>
    ifyouApi
      .post(`${ADMIN}/coin-currency-thumbnail`, {
        currency: product,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinCurrencyThumb_LIVE: (product) =>
    ifyouApiLive
      .post(`${ADMIN}/coin-currency-thumbnail`, {
        currency: product,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  coinCurrencyList_LIVE: (inputWord) =>
    ifyouApiLive
      .post(`${ADMIN}/coin-currency-list`, {
        search_word: inputWord,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const coinStoreDropApi = {
  thumbnailImgList: () =>
    ifyouApi
      .post(`${STORY}/-1/com-design-select`, { design_type: 'coin_thumbnail' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
